
import React from 'react';

const ProductLoadingState = () => {
  return (
    <div className="container mx-auto py-16 px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="animate-pulse">
          <div className="w-full aspect-square bg-gray-300 dark:bg-gray-700 rounded-lg mb-4"></div>
          <div className="flex space-x-2 mb-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="w-16 h-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
            ))}
          </div>
        </div>
        
        <div className="animate-pulse">
          <div className="h-8 bg-gray-300 dark:bg-gray-700 rounded w-3/4 mb-4"></div>
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-1/2 mb-6"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full mb-2"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full mb-2"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-3/4 mb-6"></div>
          
          <div className="h-12 bg-gray-300 dark:bg-gray-700 rounded w-full mb-6"></div>
          
          <div className="space-y-4">
            <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
            <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
            <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductLoadingState;
